import type { BlockField } from '@/blocks/domain/types';
import type { CustomerBlockContent } from '@/blocks/domain/types/BlockContent/CustomerBlockContent';
import { defaultFieldsFor } from './defaultFieldsFor';
import { defaultSignatureSections } from './signatureDefaults';

/**
 * A fresh Bill to / Job site block (LLAMS-844): the default fields name their own section and column, so
 * the block starts with one real 2-column section (Bill to | Job site) instead of flat content the editor
 * has to re-derive from the heading positions on every open. Fields a host registered in the legacy flat
 * shape name no section and keep the flat layout (the editor promotes them in memory on open).
 */
export function defaultCustomerContent(documentTypeKey?: string | null): CustomerBlockContent {
  const fields: BlockField[] = defaultFieldsFor('customer_block', documentTypeKey);
  const sections = defaultSignatureSections(fields);
  return sections ? { kind: 'customer_block', fields, sections } : { kind: 'customer_block', fields };
}
